import React from "react";
import Image from 'next/image';
import classNames from "classnames";
import dynamic from 'next/dynamic';

import { makeStyles } from "@material-ui/core/styles";

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { ssr: true });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
import teamStyle from "/styles/jss/bbhost/pages/landingPageSections/teamStyle.js";
const styles = {
    ...landingPage,
    ...teamStyle
};
const useStyles = makeStyles(styles);

import HeaderSection from "pages-sections/HeaderSection.js";
import { CheckCircle } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import datacenterImg from "public/img/datacenter.jpg"


const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { ssr: true });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'), { ssr: true });
const InfoArea = dynamic(() => import('/components/InfoArea/InfoArea.js'), { ssr: true });
const Message = dynamic(() => import('/components/Functions/Message.js'), { ssr: true });
const Button = dynamic(() => import('/components/CustomButtons/Button.js'), { ssr: true });

import { trans } from "lang/lang.js";

const SEO = {
  title: "BB Host - Colocation",
  description: "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a operação.",
  url: "https://www.bbhost.com.br/colocation",
  type: "website",
  languageAlternates: [
    {
        hrefLang: 'en',
        href: "https://www.bbhost.com.br/en/colocation",
    },
    {
        hrefLang: 'es',
        href: "https://www.bbhost.com.br/es/colocation",
    }
  ],
};

export default function Colocation(props) {
  const classes = useStyles();

  return (
    <div>
      <HeaderSection name="colocation" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <h2 className={classes.title}>{trans("colocation::title")}</h2>
            <p className={classes.title}>{trans("colocation::subTitle")}</p>
            <GridContainer justifyContent="center" alignItems="center">            
                <GridItem xs={12} sm={12} md={6}>
                    <Image src={datacenterImg} alt="Data Center" width="540px" height="450px" priority="false" />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <GridContainer justifyContent="center" alignItems="flex-start">
                        <GridItem xs={10} sm={10} md={10}>
                            <InfoArea 
                                iconColor="info" 
                                icon={CheckCircle} 
                                title="" 
                                description={trans("colocation::resources.redundancy")}
                            />
                        </GridItem>
                        <GridItem xs={10} sm={10} md={10}>
                            <InfoArea 
                                iconColor="info" 
                                icon={CheckCircle} 
                                title="" 
                                description={trans("colocation::resources.diferencial")}
                            />
                        </GridItem>
                        <GridItem xs={10} sm={10} md={10}>
                            <InfoArea 
                                iconColor="info" 
                                icon={CheckCircle} 
                                title="" 
                                description={trans("colocation::resources.types")}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
            <GridContainer justifyContent="center" alignItems="center">
              <GridItem xs={12} sm={12} md={8}>
                <Message>
                    {trans("colocation::contact")}
                </Message>
              </GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={12} sm={12} md={4}>
                    <Button href="https://financeiro.bbhost.com.br/link.php?id=193" color="success" simple target="_blank">
                        <FontAwesomeIcon icon={["fab", "whatsapp"]} size="4x" /> Whatsapp
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button href="https://financeiro.bbhost.com.br/link.php?id=206" color="github" simple target="_blank">
                        <FontAwesomeIcon icon={["fab", "discord"]} size="4x" /> Discord
                    </Button>
                  </GridItem>
                </GridContainer> 
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getServerSideProps({ req, res }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=86400, stale-while-revalidate=86400'
  );
  return {
    props: { }
  }
}